import React, {useEffect, useState} from "react";
import Header from "./Header";
import Footer from "./Footer";
import {isNotEmpty, val} from "../utils/strings";
import {fetchPost} from "../utils/fetch";
import {url} from "../utils/urls";
import {popErrors} from "../utils/message";
import FixedLoading from "../components/loading/FixedLoading";
import {img} from "../utils/image";
import {convertToKeyMapElements, isNullOrEmpty} from "../utils/objects";
import useAuth from "../auth/useAuth";
import parse from "html-react-parser";

const _title_suffix = " | " + (isNotEmpty(_TITLE_POSTFIX) ? _TITLE_POSTFIX : "Giftomize");

const Layout = ({
                  children,
                  isHeader = true,
                  isFooter = true,
                  isMiniFooter = false,
                  meta: {
                    title = "",
                    description = "",
                  },
                  pageCommonClass = "",
                  pageCommonStyle = {},
                  pageLoading = false,
                  isCommonInfo = true,
                }
                ) => {
  const { setAuthed, setTheme, theme, setLottery} = useAuth();

  const [ loading, setLoading ] = useState(true);

  const [ tel, setTel ] = useState("");
  const [ hours, setHours ] = useState("");

  const [limitDate, setLimitDate] = useState("");
  const [copyright, setCopyright] = useState("");

  const [ logo, setLogo ] = useState(url("/img/logo_blank.png")) ;
  const [ mainLogo, setMainLogo ] = useState(url("/img/main_logo_blank.png")) ;
  const [ footerLogo, setFooterLogo ] = useState(url("/img/logo_blank.png")) ;

  const [ innerHeaderStyle,  setInnerHeaderStyle ] = useState({});
  const [ innerHeaderTitle,  setInnerHeaderTitle ] = useState("　");
  const [ innerHeaderTopStyle,  setInnerHeaderTopStyle ] = useState({});
  const [ innerHeaderMiniStyle,  setInnerHeaderMiniStyle ] = useState({});


  const [ innerCommonStyle,  setInnerCommonStyle ] = useState({});
  const [ innerCommonClass,  setInnerCommonClass ] = useState("");
  const [ innerCommonCss, setInnerCommonCss ] = useState("");

  const [ innerFooter,  setInnerFooter ] = useState({});
  const [ innerFooterImage,  setInnerFooterImage ] = useState({});

  const [ innerGoodsBackCss, setInnerGoodsBackCss] = useState("");

  const [footerSearch, setFooterSearch] = useState({});
  const [footerHistory, setFooterHistory] = useState({});

  const [ menuList, setMenuList] = useState([]);
  const [ categoryMenuList, setCategoryMenuList] = useState([]);
  const [ shopMenuList, setShopMenuList] = useState([]);

  const [ loadingBack, setLoadingBack] = useState("black");

  const [ isWhiteMode, setWhiteMode] = useState(false);

  let ignore = false;
  useEffect(() => {
    if(!ignore) {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ignore = true;
      if(isCommonInfo) {
        // --------------------------------
        // 共通テーマ、情報の取得・設定
        // --------------------------------
        fetchPost({
          action: url("/api/page/get/common"),
          data: {}
        })
          .then((result) => {
            if(!result["login"]) {
              setAuthed(false);
              setLottery(false);
            }

            // 電話
            setTel(result["tel"]);
            // 営業時間
            setHours(result["hours"]);
            // 使用期限日
            setLimitDate(result["useLimitDate"]);

            // ------------------------------------
            // 共通メニューを取得して設定する
            // ------------------------------------
            setMenuList(result["menuElements"] ?? []);

            // ------------------------------------
            // カテゴリメニューを取得して設定する
            // ------------------------------------
            setCategoryMenuList(result["categoryMenuElements"] ?? []);

            // ------------------------------------
            // ショップメニューを取得して設定する
            // ------------------------------------
            setShopMenuList(result["shopMenuElements"] ?? []);

            // ------------------------------------
            // 共通のスタイルを取得して適用する
            // ------------------------------------
            let mapElements = convertToKeyMapElements(result["commonElements"]);
            if (mapElements) {
              // --------------
              // 共通設定
              // --------------
              const commonElement = mapElements["common"];
              setLoadingBack(commonElement["style"]["backgroundColor"]);
              // 共通スタイル
              setInnerCommonStyle(commonElement["style"]);
              // 共通Class
              const commonClassName = commonElement["attr"]["className"];
              setInnerCommonClass(commonClassName);
              // 共通css
              setInnerCommonCss(commonElement["css"]);

              // --------------
              // 商品背景
              // --------------
              const goodsBackElement = mapElements["goods_back"];
              const backCssString =`
              .pho.zoom {
                background-color: ${val(goodsBackElement["style"]["backgroundColor"], "white")};
                padding-top: ${val(goodsBackElement["style"]["paddingTop"], "0")};
                padding-right: ${val(goodsBackElement["style"]["paddingRight"], "0")};
                padding-bottom: ${val(goodsBackElement["style"]["paddingBottom"], "0")};
                padding-left: ${val(goodsBackElement["style"]["paddingLeft"], "0")};
              }`;
              console.log(backCssString);
              setInnerGoodsBackCss(backCssString);
              // --------------
              // ヘッダ
              // --------------
              setInnerHeaderStyle(mapElements["header"]["style"]);
              setInnerHeaderTopStyle(mapElements["header_top"]?.["style"]);
              setInnerHeaderMiniStyle(mapElements["header_mini"]?.["style"]);
              // --------------
              // ヘッダタイトル
              // --------------
              setInnerHeaderTitle(mapElements["header_title"]["innerText"])
              // --------------
              // ロゴ
              // --------------
              setLogo(img(mapElements["header_logo_small"]["attr"]["src"]));
              // --------------
              // メインロゴ
              // --------------
              setMainLogo(img(mapElements["header_logo"]["attr"]["src"]));
              // --------------
              // フッタロゴ
              // --------------
              if(isNullOrEmpty(mapElements["footer_logo"])) {
                setFooterLogo(img(mapElements["header_logo_small"]["attr"]["src"]));
              } else {
                setFooterLogo(img(mapElements["footer_logo"]["attr"]["src"]));
              }
              // --------------
              // copyright
              // --------------
              setCopyright(mapElements["copyright"]);
              // --------------
              // フッタ
              // --------------
              setInnerFooter(mapElements["footer"]);
              // --------------
              // フッタ画像
              // --------------
              setInnerFooterImage(mapElements["footer_image"]);
              // --------------
              // フッタ検索
              // --------------
              setFooterSearch(mapElements["footer_searchbox"]);
              // --------------
              // フッタ商品履歴
              // --------------
              setFooterHistory(mapElements["footer_history"]);
              // -------------
              // テーマ
              // -------------
              const theme = mapElements.theme?.innerText;
              setTheme(theme);
              if(theme === "white") {
                setWhiteMode(true);
              }


            }
          })
          .catch((reason) => {
            console.log("layoutError:" + reason);
            popErrors(reason);
          })
          .finally(() => {
            ignore = false;
            setLoading(false);
          });
      } else {
        setLoading(false);
      }

      // titleタグの設定
      if (isNotEmpty(title)) {
        document.title = title + _title_suffix;
      }
      // meta descriptionの設定
      if (isNotEmpty(description)) {
        document.querySelector('meta[name="description"]')
          .setAttribute("content", description);
      }
    }
  }, []);

  return (
    <div id="main-layout" className={innerCommonClass + (theme === "white" ? " whiteBg": "")} style={innerCommonStyle}>
      {isNotEmpty(innerCommonCss) && <style>{parse(innerCommonCss)}</style>}
      {isNotEmpty(innerGoodsBackCss) && <style>{parse(innerGoodsBackCss)}</style>}
      <div className={pageCommonClass} style={pageCommonStyle}>
        {/*ページ全体ローディング*/}
        {(loading || pageLoading) &&
          <FixedLoading backgroundColor={loadingBack} />
        }
        {/*ヘッダ*/}
        {isHeader && <Header
          headerStyle={innerHeaderStyle}
          headerTopStyle={innerHeaderTopStyle}
          headerMiniStyle={innerHeaderMiniStyle}
          logo={logo}
          mainLogo={mainLogo}
          title={innerHeaderTitle}
          menus={menuList}
          pcMenus={categoryMenuList}
          shopMenus={shopMenuList}
          useLimitDate={limitDate}
          isWhiteMode={isWhiteMode}
        />}
        {/*ページ毎の記述*/}
        {children}
        {/*フッタ*/}
        {isFooter && <Footer
          footerElement={innerFooter}
          shopMenus={shopMenuList}
          tel={tel}
          hours={hours}
          logo={footerLogo}
          isWhiteMode={isWhiteMode}
          footerSearch={footerSearch}
          footerHistory={footerHistory}
          footerImage={innerFooterImage}
          copyright={copyright}
          isMiniFooter={isMiniFooter}
        />}
      </div>
    </div>
  )
};
export default Layout;